module.exports = __webpack_public_path__ + "img/rbg-sydney.572a9d8a.png";